import {autoSizeAllColumns} from "../helpers/autoSizeAllColumns";
import {scrollToFirstSelectedRow} from "../helpers/scrollToFirstSelectedRow";

export function switchToGrid(event) {
	window.location.hash = '';

  if (gridSettings.api.getDisplayedRowCount() === 0) {
    document.querySelector("body").dispatchEvent(myEvent);
  }

	$('[data-role="list"]').show()
	$('[data-role="detail"]').hide()

	$('#toolbar').data("kendoToolBar").remove($('#detailMenuSeparator'));
	$('#toolbar').data("kendoToolBar").remove($('#detailMenu'));

	autoSizeAllColumns();

	scrollToFirstSelectedRow();
}
